<template>
  <navBar
    current="home"
    :visible="showNav"
    :bg="swiperIndex === 0"
    :whiteLogo="swiperIndex === 5 || swiperIndex === 9"
    :whiteLabel="swiperIndex === 1 || swiperIndex === 3 || swiperIndex === 4"
    @change="
      if ($refs.slide1) $refs.slide1.distoryPlayer();
      if ($event == 'home') swiper.slideTo(0);
    "
  ></navBar>

  <swiper
    :class="['home-swiper full-screen']"
    :simulateTouch="false"
    :freeMode="screenWidth <= 1200"
    direction="vertical"
    :mousewheel="screenWidth <= 1200 ? { sensitivity: 5 } : true"
    :lazy="{ loadPrevNext: true }"
    :pagination="
      showNav ? { clickable: true, bulletClass: 'home-swiper-bullet' } : false
    "
    @slideChange="swiperIndex = $event.activeIndex"
    @swiper="swiper = $event"
  >
    <swiper-slide
      ><slide1 ref="slide1" @showVideo="showNav = !$event"
    /></swiper-slide>
    <swiper-slide><slide2 /></swiper-slide>
    <swiper-slide><slide3 /></swiper-slide>
    <swiper-slide><slide4 /></swiper-slide>
    <swiper-slide><slide5 /></swiper-slide>
    <swiper-slide><slide6 /></swiper-slide>
    <swiper-slide><slide7 /></swiper-slide>
    <swiper-slide><slide8 /></swiper-slide>
    <swiper-slide><slide9 /></swiper-slide>
    <swiper-slide><slide10 /></swiper-slide>
  </swiper>

  <img
    alt="logo"
    id="logo"
    class="logo"
    style="position: absolute; pointer-events: none; margin-left: -500px"
    :src="require('/src/assets/images/logo.jpg')"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import navBar from "../../components/nav-bar/nav-bar.vue";
import HOME_SLIDE_COMPONENTS from "./slide-components";

import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Mousewheel, Pagination, Lazy } from "swiper";
require("swiper/swiper.less");
require("swiper/components/pagination/pagination.less");
require("swiper/components/lazy/lazy.less");

const SWIPER_COMPONENTS = {
  Swiper,
  SwiperSlide,
};

SwiperCore.use([Pagination, Mousewheel, Lazy]);
export default defineComponent({
  components: {
    navBar,
    ...SWIPER_COMPONENTS,
    ...HOME_SLIDE_COMPONENTS,
  },

  data() {
    return {
      swiper: null,
      swiperIndex: 0,
      swiperSlides: [],
      showNav: true,
      screenWidth: document.body.clientWidth,
    };
  },

  mounted() {
    window.onresize = () => {
      let width = document.body.clientWidth;
      if ((this.screenWidth <= 1024 && width > 1024) || (this.screenWidth > 1024 && width <= 1024)) {
        location.reload();
      }
      this.screenWidth = width;
    };
  },
});
</script>

<style lang="less" scope src="./home.less"></style>
